// Event-type theming: accent tokens + copy tone + icon + labels.
import {
  Flower2, Cake, Heart, Gift, Briefcase, GraduationCap, Plane, Sparkles,
} from "lucide-react";

export const EVENT_TYPES = [
  { key: "memorial", label: "Memorial / Celebration of Life", short: "Memorial", icon: Flower2,
    accent: "35 38% 45%", accentSoft: "35 55% 92%", accentInk: "28 22% 18%", chipBg: "35 55% 92%",
    framing: "In loving memory of", tone: "gentle",
    invite: "Share a memory of {name} for the family.",
    heroWash: "radial-gradient(1200px 600px at 20% 0%, hsla(35,55%,92%,0.9), transparent 60%), radial-gradient(900px 500px at 90% 10%, hsla(28,35%,90%,0.7), transparent 55%)" },
  { key: "birthday", label: "Birthday", short: "Birthday", icon: Cake,
    accent: "196 62% 38%", accentSoft: "196 55% 92%", accentInk: "196 70% 18%", chipBg: "196 55% 92%",
    framing: "Celebrating", tone: "joyful",
    invite: "Send {name} a birthday message they'll never forget.",
    heroWash: "radial-gradient(900px 520px at 15% 0%, hsla(196,55%,92%,0.95), transparent 60%), radial-gradient(700px 420px at 85% 10%, hsla(38,85%,90%,0.7), transparent 55%)" },
  { key: "wedding", label: "Wedding", short: "Wedding", icon: Heart,
    accent: "346 45% 46%", accentSoft: "346 55% 93%", accentInk: "346 55% 18%", chipBg: "346 55% 93%",
    framing: "With love, for", tone: "romantic",
    invite: "Share your love and wishes for {name}.",
    heroWash: "radial-gradient(1000px 560px at 20% 0%, hsla(346,55%,93%,0.95), transparent 60%), radial-gradient(800px 480px at 90% 10%, hsla(35,55%,92%,0.65), transparent 55%)" },
  { key: "anniversary", label: "Anniversary", short: "Anniversary", icon: Gift,
    accent: "18 55% 44%", accentSoft: "18 60% 92%", accentInk: "18 55% 18%", chipBg: "18 60% 92%",
    framing: "Honoring", tone: "nostalgic",
    invite: "Celebrate {name} with a memory or a wish.",
    heroWash: "radial-gradient(1000px 560px at 20% 0%, hsla(18,60%,92%,0.95), transparent 60%), radial-gradient(800px 480px at 90% 10%, hsla(35,55%,92%,0.65), transparent 55%)" },
  { key: "retirement", label: "Retirement", short: "Retirement", icon: Briefcase,
    accent: "152 32% 32%", accentSoft: "152 30% 92%", accentInk: "152 40% 16%", chipBg: "152 30% 92%",
    framing: "Celebrating", tone: "grateful",
    invite: "Send {name} off with gratitude and good memories.",
    heroWash: "radial-gradient(1000px 560px at 20% 0%, hsla(152,30%,92%,0.95), transparent 60%), radial-gradient(800px 480px at 90% 10%, hsla(35,55%,92%,0.65), transparent 55%)" },
  { key: "graduation", label: "Graduation", short: "Graduation", icon: GraduationCap,
    accent: "222 55% 42%", accentSoft: "222 55% 93%", accentInk: "222 55% 18%", chipBg: "222 55% 93%",
    framing: "Celebrating", tone: "proud",
    invite: "Congratulate {name} on this milestone.",
    heroWash: "radial-gradient(1000px 560px at 20% 0%, hsla(222,55%,93%,0.95), transparent 60%), radial-gradient(800px 480px at 90% 10%, hsla(35,55%,92%,0.65), transparent 55%)" },
  { key: "farewell", label: "Farewell", short: "Farewell", icon: Plane,
    accent: "268 22% 40%", accentSoft: "268 25% 93%", accentInk: "268 25% 18%", chipBg: "268 25% 93%",
    framing: "With gratitude, for", tone: "appreciative",
    invite: "Wish {name} well on the road ahead.",
    heroWash: "radial-gradient(1000px 560px at 20% 0%, hsla(268,25%,93%,0.95), transparent 60%), radial-gradient(800px 480px at 90% 10%, hsla(35,55%,92%,0.65), transparent 55%)" },
  { key: "other", label: "Something else", short: "Other", icon: Sparkles,
    accent: "205 55% 38%", accentSoft: "205 55% 93%", accentInk: "205 55% 18%", chipBg: "205 55% 93%",
    framing: "For", tone: "warm",
    invite: "Share a message for {name}.",
    heroWash: "radial-gradient(1000px 560px at 20% 0%, hsla(205,55%,93%,0.95), transparent 60%), radial-gradient(800px 480px at 90% 10%, hsla(35,55%,92%,0.65), transparent 55%)" },
];

export function getTheme(typeKey) {
  return EVENT_TYPES.find((t) => t.key === typeKey) || EVENT_TYPES[0];
}

export function themeStyle(typeKey) {
  const t = getTheme(typeKey);
  return {
    "--theme-accent": t.accent,
    "--theme-accent-soft": t.accentSoft,
    "--theme-accent-ink": t.accentInk,
    "--theme-chip-bg": t.chipBg,
  };
}

export function eventTitle(typeKey, name) {
  const t = getTheme(typeKey);
  return `${t.framing} ${name}`;
}
